import React, {createContext, useContext, useState, FC} from 'react'

interface BatchApprovalContextValue {
  selectedDocs: Map<number, any>
  toggleDoc: (doc: any) => void
  clearAll: () => void
}

const BatchApprovalContext = createContext<BatchApprovalContextValue>({
  selectedDocs: new Map(),
  toggleDoc: () => {},
  clearAll: () => {},
})

export const BatchApprovalProvider: FC<{children: React.ReactNode}> = ({children}) => {
  const [selectedDocs, setSelectedDocs] = useState<Map<number, any>>(new Map())

  const toggleDoc = (doc: any) => {
    setSelectedDocs((prev) => {
      const next = new Map(prev)
      if (next.has(doc.id)) {
        next.delete(doc.id)
      } else {
        next.set(doc.id, doc)
      }
      return next
    })
  }

  const clearAll = () => setSelectedDocs(new Map())

  return (
    <BatchApprovalContext.Provider value={{selectedDocs, toggleDoc, clearAll}}>
      {children}
    </BatchApprovalContext.Provider>
  )
}

export const useBatchApproval = () => useContext(BatchApprovalContext)
